/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_3_DescInputs */

const tr_landing_intro_stat_3_desc = /** @type {(inputs: Landing_Intro_Stat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir abonelik, tüm özellikler. Gelecek güncellemeler dahil.`)
};

const en_landing_intro_stat_3_desc = /** @type {(inputs: Landing_Intro_Stat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One subscription, every feature. Future updates included.`)
};

const de_landing_intro_stat_3_desc = /** @type {(inputs: Landing_Intro_Stat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Abo, alle Funktionen. Künftige Updates inklusive.`)
};

const ru_landing_intro_stat_3_desc = /** @type {(inputs: Landing_Intro_Stat_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одна подписка, все функции. Будущие обновления включены.`)
};

/**
* | output |
* | --- |
* | "One subscription, every feature. Future updates included." |
*
* @param {Landing_Intro_Stat_3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_3_desc = /** @type {((inputs?: Landing_Intro_Stat_3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_3_desc(inputs)
	if (locale === "de") return de_landing_intro_stat_3_desc(inputs)
	if (locale === "ru") return ru_landing_intro_stat_3_desc(inputs)
	return tr_landing_intro_stat_3_desc(inputs)
});